import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 bg-white" data-id="element-84">
      <div className="container mx-auto px-4" data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          {/* Part 1: The Cycle */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="prose prose-lg md:prose-xl text-gray-700 mb-16" data-id="element-87">
            <p className="text-2xl md:text-3xl font-serif text-purple-900 mb-6 font-bold" data-id="element-88">
              Cobras. Respiras.
            </p>
            <p data-id="element-89">Por unas horas sientes alivio.</p>
            <p data-id="element-90">
              Pagas lo urgente. Compras lo que hacía falta. Te pones al día.
            </p>
            <p data-id="element-91">Pero en el fondo… sabes lo que viene.</p>
            <p data-id="element-92">Porque ya lo has vivido antes.</p>

            <div className="my-10 space-y-4 border-l-4 border-purple-300 pl-6 py-2 bg-purple-50/50 rounded-r-lg" data-id="element-93">
              <p className="font-bold text-purple-900" data-id="element-94">
                <span className="text-pink-600" data-id="element-95">Día 3.</span> La mitad del
                dinero ya desapareció.
              </p>
              <p className="font-bold text-purple-900" data-id="element-96">
                <span className="text-pink-600" data-id="element-97">Día 5.</span> Empiezas a hacer
                cálculos mentales.
              </p>
              <p className="font-bold text-purple-900" data-id="element-98">
                <span className="text-pink-600" data-id="element-99">Día 8.</span> Regresa la
                ansiedad.
              </p>
            </div>

            <p data-id="element-100">No porque seas irresponsable. No porque ganes poco.</p>
            <p className="font-semibold text-purple-800 text-xl" data-id="element-101">
              Sino porque estás viviendo sin oxígeno financiero.
            </p>
            <p data-id="element-102">Y eso agota.</p>
          </motion.div>

          {/* Part 2: Empathy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-[#F5F0FF] rounded-3xl p-8 md:p-12 mb-16 shadow-sm" data-id="element-103">
            <h2 className="text-3xl md:text-4xl font-bold text-purple-900 mb-6" data-id="element-104">
              No Estás Fallando
            </h2>
            <p className="text-lg mb-4" data-id="element-105">Déjame decirte algo claro:</p>
            <p className="text-xl font-bold text-pink-600 mb-6" data-id="element-106">
              No estás quebrada. No eres mala con el dinero. No eres incapaz.
            </p>
            <p className="text-lg mb-6" data-id="element-107">
              Estás usando un sistema que nunca fue diseñado para ti.
            </p>
            <p className="text-lg mb-4" data-id="element-108">
              La mayoría de los consejos financieros fueron creados para:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-8" data-id="element-109">
              <li data-id="element-110">Personas con ingresos mensuales.</li>
              <li data-id="element-111">Gente sin responsabilidades familiares.</li>
              <li data-id="element-112">Personas con tiempo para Excel infinitos.</li>
              <li data-id="element-113">Mentalidad fría y lineal.</li>
            </ul>

            <p className="text-xl font-bold text-purple-900 mb-4" data-id="element-114">
              Pero tú no vives así.
            </p>
            <p className="text-lg mb-4" data-id="element-115">
              Eres mujer latina. Trabajas. Resuelves. Sostienes a otros.
            </p>
            <p className="text-lg mb-4" data-id="element-116">Tu dinero no es solo números.</p>
            <p className="text-xl font-semibold text-purple-800 italic mb-4" data-id="element-117">
              Es emocional. Es familiar. Es dinámico.
            </p>
            <p className="text-lg" data-id="element-118">Y nadie te enseñó a manejar eso.</p>
          </motion.div>

          {/* Part 3: The Silent Pain */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="prose prose-lg md:prose-xl text-gray-700" data-id="element-119">
            <h2 className="text-3xl md:text-4xl font-bold text-purple-900 mb-6" data-id="element-120">
              El Dolor Que No Dices En Voz Alta
            </h2>
            <p data-id="element-121">Te haces preguntas que no compartes con nadie:</p>
            <blockquote className="italic text-purple-800 border-l-4 border-pink-400 pl-4 my-6" data-id="element-122">
              “¿En qué se me fue el dinero?” “¿Por qué otras sí pueden ahorrar?”
              “¿Soy mala administrando?”
            </blockquote>
            <p data-id="element-123">Y lo peor no es quedarte sin dinero.</p>
            <p className="font-semibold" data-id="element-124">
              Es sentir que trabajas demasiado… para estar siempre justa.
            </p>
            <p data-id="element-125">
              Es ese nudo en el estómago cuando llega una notificación del
              banco.
            </p>
            <p data-id="element-126">
              Es el miedo silencioso a que cualquier imprevisto te
              desestabilice.
            </p>
            <p className="text-purple-700" data-id="element-127">
              Un gasto médico. Una reparación. Una emergencia.
            </p>
            <p className="text-xl font-bold text-purple-900 mt-8" data-id="element-128">
              Vives en modo supervivencia.
            </p>
            <p className="text-xl font-bold text-purple-900" data-id="element-129">
              Siempre equilibrándote. Nunca descansando.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}